<form [formGroup]="genericFormGroup" (ngSubmit)="onSubmit()">
  @for (field of fields; track field) {
    <div>
      <label>{{ field.label }}</label>
      @if (field.type === 'text' || field.type === 'email' || field.type === 'password') {
        <input
          class="form-control"
          type="text"
          [ngClass]="{ 'is-invalid': isFormSubmitted && genericFormGroup.get(field.key)!.errors }"
          formControlName="{{ field.key }}"
          [matTooltip]="field.tooltip || ''"
          [matTooltipPosition]="field.tooltipPosition || 'below'"
          placeholder="{{ field.placeholder }}" />
      }
      @if (field.type === 'date') {
        <input
          class="form-control"
          [ngClass]="{ 'is-invalid': isFormSubmitted && genericFormGroup.get(field.key)!.errors }"
          type="date"
          formControlName="{{ field.key }}" />
      }
      @if (field.type === 'time') {
        <input
          class="form-control"
          [ngClass]="{ 'is-invalid': isFormSubmitted && genericFormGroup.get(field.key)!.errors }"
          type="time"
          formControlName="{{ field.key }}" />
      }
      @if (field.type === 'number') {
        <input
          class="form-control"
          [ngClass]="{ 'is-invalid': isFormSubmitted && genericFormGroup.get(field.key)!.errors }"
          type="number"
          formControlName="{{ field.key }}" />
      }

      @if (field.type === 'textarea') {
        <textarea
          class="form-control"
          [ngClass]="{ 'is-invalid': isFormSubmitted && genericFormGroup.get(field.key)!.errors }"
          formControlName="{{ field.key }}"
          placeholder="{{ field.placeholder || '' }}"></textarea>
      }
      @if (field.type === 'select') {
        <select
          class="form-select"
          formControlName="{{ field.key }}"
          [ngClass]="{ 'is-invalid': isFormSubmitted && genericFormGroup.get(field.key)!.errors }">
          @for (option of field.options; track option) {
            <option [value]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      }
      @if (field.type === 'radio') {
        <div formArrayName="{{ field.key }}">
          @for (option of field.options; track option; let i = $index) {
            <div>
              <label [for]="field.key + i">
                <input
                  type="radio"
                  [formControlName]="field.key + i"
                  [name]="field.key"
                  [id]="field.key + i"
                  [value]="option.value" />
                <!-- {{ option.label }} -->
                {{ option.label }}</label
              >
              <!-- Corresponding label for each radio button -->
            </div>
          }
        </div>
      }

      @if (field.type === 'checkbox') {
        <div class="form-check-input" formArrayName="{{ field.key }}">
          @for (option of field.options; track option; let i = $index) {
            <div>
              <label class="form-check-label" [for]="field.key + i">
                <input class="form-check-input" [value]="option.value" />
                {{ option.label }}
              </label>
            </div>
          }
        </div>
      }
      <!-- <div class="invalid-feedback mt-5" *ngIf="field.validation?.required"> -->
      @if (isFormSubmitted && genericFormGroup.get(field.key)!.errors) {
        <div>
          @if (genericFormGroup.get(field.key)?.errors?.['required']) {
            <div>
              @if (genericFormGroup.get(field.key)?.errors?.['required']) {
                <small class="text-danger">Field is required</small>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="py-5">
    <button class="btn btn-primary" type="submit">Submit</button>
  </div>
</form>
